function CartMinimum (props) {
  const { text, minimumAmount } = props
  return (
    <div className="bg-accent-2 py-4 px-6 text-center text-sm border-b text-grey-900">{text} {`$${minimumAmount}`}</div>
  )
}

export default CartMinimum
